import {Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import ResultScreen from '@/app/shared-components/ResultScreen/ResultScreen';

const OnboardingPausedPage = () => {
  const {t} = useTranslation();

  return (
    <ResultScreen
      imgSrc="/assets/images/etc/pending.svg"
      title={
        <Typography className="title">
          {t('onboarding_paused.title')}
        </Typography>
      }
      description={
        <Typography className="description">
          {t('onboarding_paused.description')}
        </Typography>
      }
    />
  );
};

export default OnboardingPausedPage;
